import {combineReducers} from "redux"


import PageState from './PageState/PagesState'


export default combineReducers({
    PageState
})